import React from "react";

const SwitchButton = ({ inputClass, name, onChange, checked, id }) => {
  return (
    <div className="switch-button">
      <input
        id={id}
        type="checkbox"
        className={inputClass}
        name={name}
        onChange={(e) => {
          onChange(e);
        }}
        checked={checked}
      />
      <label htmlFor={id} />
    </div>
  );
};

export default SwitchButton;
